import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { Link } from 'gatsby';

export const Wrapper = styled.div`
  display: none;

  ${media.md`
    display: flex;
    justify-content: center;
    align-items: center;
  
    align-self: stretch;
  
    background: var(--Primary-Darknet, #1c1c1c);
    gap: 24px;
    padding: 32px 40px;
  `}
  ${media.lg`
    padding: 42px 70px;
    gap: 24px;
  `}
  ${media.xl`
    padding: 50px 84px;
    gap: 24px;
  `}
`;

export const StyledGatsbyLink = styled(Link)`
  font-size: 16px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  line-height: 22px;
  color: var(--Primary-Skychain, #4169e1);
  background: none;
  box-shadow: none;
  font-weight: 500;
  text-decoration: none;
`;

export const Itemswrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;

  ${media.md`
    
    align-items: center;
    gap: 24px;
    align-self: stretch;
  `}
  ${media.lg`
    
    gap: 32px;
  `}
  ${media.xl`
    
    gap: 40px;
  `}
`;

export const IconImage = styled.img`
  width: 48px;
  height: 68px;
  aspect-ratio: 12/17;
  ${media.md`
    width: 60px;
    height: 85px;
    aspect-ratio: 12/17;
  `}
  ${media.lg`
    width: 75px;
    height: 109.263px;
    aspect-ratio: 98.00/139.26;
  `}
  ${media.xl`
    width: 98px;
    height: 139.263px;
    aspect-ratio: 98.00/139.26;
  `}
`;

export const NumberTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
`;

export const Number = styled.h2`
  color: var(--Primary-White-Paper, #fff);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};

  font-style: normal;
  font-size: 34px;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-transform: uppercase;
  margin: 0px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  ${media.md`
    font-size: 40px;

    line-height: 85%; 
    letter-spacing: -0.88px;
  `}
  ${media.lg`
    font-size: 53px;

    letter-spacing: -1.2px;
  `}
  ${media.xl`
    font-size: 65px;
    
    letter-spacing: -1.4px;
  `}
`;

export const Text = styled.h2`
  color: var(--Shades-600, #818085);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: 27px;
  font-style: normal;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-transform: uppercase;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  margin: 0px;
  ${media.md`
    font-size: 40px;
    line-height: 85%;
    letter-spacing: -0.88px;
  `}
  ${media.lg`
    font-size: 53px;

    letter-spacing: -1.2px;
  `}
  ${media.xl`
    font-size: 64px;
    
    letter-spacing: -1.4px;
  `}
`;

export const StyledButton = styled.button`
  display: none;
  border: none !important;
  ${media.md`
    display: flex;
    border:none;
    justify-content: center;
    align-items: center;
    gap: 9.293px;
    border-radius: 116.162px;
    background: var(--orange-500, #ff9500);
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--Grey-Scale-900, #1c1c1c);
    text-align: center;
    font-family: "Satoshi Variable Medium", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    cursor:pointer;
    position: relative;
    overflow: hidden;
    z-index: 1;
    border: none !important;
    transition: background 0.3s ease, color 0.3s ease;
  
    &:hover {
      background: #ff7c18;
    }
  
    .ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: ripple-animation 1.5s ease-out;
      background-color: rgba(204, 85, 0, 0.6);
      pointer-events: none;
      z-index: 0;
    }
  
    @keyframes ripple-animation {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `}
  ${media.lg`
    
    font-size: 16px;
    padding: 14px 27.879px;
  `}
  ${media.xl`
    
    font-size: 20px;
  `}
`;

export const Mobilewrapper = styled.div`
  display: flex;
  padding: 24px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background: var(--Primary-Darknet, #1c1c1c);
  ${media.md`
    
    display:none;
  `}
`;

export const NumberTextWrappermobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;
